import vehicleOverviewTimelineByDay from './vehicle-overview-timeline-by-day';
import { type GetVehicleOverviewResponseVM } from '@/app/services/solution/types/get-vehicle-overview';

const vehicleOverviewResponse: GetVehicleOverviewResponseVM = {
  energyConsumptionKWhPerKm: 1.148_889_778_291_075_6,
  typicalDistance: 137,
  duration: 120,
  idling: 45,
  maxGtwKg: 34_000,
  avgGtwKg: 25_000,
  chargingNeedKwh: 178,
  routeAltitude: [
    { altitude: 20, distance: 0 },
    { altitude: 19, distance: 1 },
    { altitude: 18, distance: 2 },
    { altitude: 15, distance: 3 },
    { altitude: 14, distance: 4 },
    { altitude: 12, distance: 5 },
    { altitude: 10, distance: 6 },
    { altitude: 8, distance: 7 },
    { altitude: 7, distance: 8 },
    { altitude: 6, distance: 9 },
    { altitude: 2, distance: 10 },
    { altitude: 0, distance: 11 },
    { altitude: -5, distance: 12 },
    { altitude: -10, distance: 13 },
    { altitude: -11, distance: 14 },
    { altitude: -12, distance: 15 },
    { altitude: -12, distance: 16 },
    { altitude: -12, distance: 17 },
    { altitude: -12, distance: 18 },
    { altitude: -10, distance: 19 },
    { altitude: 0, distance: 20 },
    { altitude: 20, distance: 21 },
    { altitude: 30, distance: 22 },
    { altitude: 40, distance: 23 },
    { altitude: 35, distance: 30 },
    { altitude: 20, distance: 40 },
    { altitude: 5, distance: 50 },
    { altitude: 10, distance: 60 },
    { altitude: 25, distance: 70 },
    { altitude: 40, distance: 80 },
    { altitude: 30, distance: 90 },
    { altitude: 10, distance: 100 },
    { altitude: -10, distance: 110 },
    { altitude: -20, distance: 120 },
    { altitude: -30, distance: 130 },
    { altitude: -10, distance: 140 },
  ],
  batteryLevel: {
    fullBatterySoc: [
      { soc: 100, distance: 0, isWaypoint: true },
      { soc: 90, distance: 20, isWaypoint: false },
      { soc: 80, distance: 40, isWaypoint: true },
      { soc: 70, distance: 60, isWaypoint: true },
      { soc: 90, distance: 60, isWaypoint: true },
      { soc: 80, distance: 100, isWaypoint: true },
      { soc: 70, distance: 120, isWaypoint: false },
      { soc: 60, distance: 140, isWaypoint: true },
    ],
    lowerBatterySoc: [
      { soc: 75, distance: 0, isWaypoint: true },
      { soc: 70, distance: 20, isWaypoint: false },
      { soc: 60, distance: 40, isWaypoint: true },
      { soc: 50, distance: 60, isWaypoint: true },
      { soc: 70, distance: 60, isWaypoint: true },
      { soc: 60, distance: 100, isWaypoint: true },
      { soc: 50, distance: 120, isWaypoint: false },
      { soc: 40, distance: 140, isWaypoint: true },
    ],
  },
  timeline: vehicleOverviewTimelineByDay.monday,
};

export default vehicleOverviewResponse;
